import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { SignupComponent } from './signup/signup.component';
import { SigninComponent } from './signin/signin.component';
// import { NgChartsModule } from 'ng2-charts';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { NgxSpinnerModule } from "ngx-spinner";
import { TokenInterCepterService } from './token-inter-cepter.service';
import { DatePipe } from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';
// import { AuthServiceConfig } from 'angular-6-social-login';
// import { GoogleLoginProvider, FacebookLoginProvider } from 'angular-6-social-login';
import {SdpLayoutsModule} from './sdp/sdp-layouts/sdp-layouts.module'
import { ScriptLoaderService } from './_services/script-loader.service';
import {RouteResolver} from './resolvers/route.resover';
import {RestirctNumberScrollDirective} from './directives/restirct-number-scroll.directive';
import { SharedModule } from './shared/shared.module';
import { ServerDownComponent } from './server-down/server-down.component';
// import { ClosedComplaintsComponent } from './sdp/officer/closed-complaints/closed-complaints.component';
// import { EscalatedComplaintsComponent } from './sdp/officer/escalated-complaints/escalated-complaints.component';

// export function socialConfigs() {

//   const config = new AuthServiceConfig(
//     [
//       {
//         id: FacebookLoginProvider.PROVIDER_ID,
//         provider: new FacebookLoginProvider('310166580213096')
//       },
//       {
//         id: GoogleLoginProvider.PROVIDER_ID,
//         provider: new GoogleLoginProvider('1042901570212-e2l3f0ja5h9uvhot3i8echbhsp4pupa3.apps.googleusercontent.com')
//       }
//     ]
//   );

//   return config;
// }
// ec
@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    RestirctNumberScrollDirective,
    ServerDownComponent,
    // ClosedComplaintsComponent,
    // EscalatedComplaintsComponent

  ],
  imports: [
    SdpLayoutsModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    FileUploadModule,
    NgSelectModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    NgxSpinnerModule,
    MatSortModule,
    DatePipe,
    MatTooltipModule,
    MatDividerModule,
    SharedModule,
  ],

  providers: [RouteResolver,
    ScriptLoaderService,
    // AuthService,
    DatePipe,
    // {
    //   provide: AuthServiceConfig,
    //   useFactory: socialConfigs
    // },
     {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterCepterService,
      multi: true
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
